import React, { FC, useState } from 'react';
import { MODAL_NAME_AUTH } from '../../constants/modalNamesConstants';
import { useModal } from '../../hooks/useModal';
import {
  AuthModalPayloadType, AuthStateType, LOGIN_STATE_TYPE, REGISTER_STATE_TYPE, RESET_PASSWORD_STATE_TYPE
} from './authTypes';
import ModalComponent from '../../core/components/modal/ModalComponent';
import { LoginContainer } from './login/LoginContainer';
import { RegisterContainer } from './register/RegisterContainer';
import { ResetPasswordContainer } from './resetPassword/ResetPasswordContainer';
import TabComponent from '../../core/components/tab/TabComponent';

const modalTitles = {
  [LOGIN_STATE_TYPE]: 'Авторизация',
  [REGISTER_STATE_TYPE]: 'Регистрация',
  [RESET_PASSWORD_STATE_TYPE]: 'Сброс пароля',
};

const AuthModalContainer: FC = () => {
  const { onCloseModal, payload = {} } = useModal(MODAL_NAME_AUTH);

  const { selectedAuthStateType } = payload as AuthModalPayloadType;

  const [authStateType, setAuthStateType] = useState<AuthStateType>(selectedAuthStateType || LOGIN_STATE_TYPE);

  const tabs = [
    {
      id: LOGIN_STATE_TYPE,
      title: 'Авторизация',
      Content: <LoginContainer onCloseModal={onCloseModal} onSwitchToResetPassword={() => setAuthStateType(RESET_PASSWORD_STATE_TYPE)} />,
      onChange: () => setAuthStateType(LOGIN_STATE_TYPE)
    },
    {
      id: REGISTER_STATE_TYPE,
      title: 'Регистрация',
      Content: <RegisterContainer onCloseModal={onCloseModal} />,
      onChange: () => setAuthStateType(REGISTER_STATE_TYPE)
    },
  ];

  // Добавляем скрытую вкладку сброса пароля, которая показывается только при прямом переключении
  if (authStateType === RESET_PASSWORD_STATE_TYPE) {
    tabs.push({
      id: RESET_PASSWORD_STATE_TYPE,
      title: 'Сброс пароля',
      Content: <ResetPasswordContainer onCloseModal={onCloseModal} />,
      onChange: () => setAuthStateType(RESET_PASSWORD_STATE_TYPE)
    });
  }

  return (
        <ModalComponent title={modalTitles[authStateType]} onClose={onCloseModal}>
            <TabComponent tabs={tabs} activeTabId={authStateType} />
        </ModalComponent>
  );
};

export default AuthModalContainer;
